import Vue from 'vue';
import { RenderSchema } from './RenderSchema';
import { Render } from './Render';
import { RenderAnchor } from './RenderAnchor';
import { RenderImage } from './RenderImage';
var AwaitWrapper = /** @class */ (function () {
    function AwaitWrapper() {
    }
    AwaitWrapper.install = function () {
        Vue.component('RenderSchema', RenderSchema);
    };
    return AwaitWrapper;
}());
export default AwaitWrapper;
export { RenderSchema, Render, RenderAnchor, RenderImage };
//# sourceMappingURL=index.js.map